<div class="heading-div">
  <div class="heading-content">
    <h1 class="heading-title">Your possible futures</h1>
    <p class="sub-title">
      Careers for you, based on your interests and background.
      Choose a career to learn more.
    </p>
  </div>

  <div class="search-container" [class.expanded]="isExpanded">
    <div class="search-icon-wrapper" (click)="toggleSearch()" (keydown.enter)="toggleSearch()" (keydown.space)="$event.preventDefault(); toggleSearch()" tabindex="0" role="button" aria-label="Search">
      <img *ngIf="!isExpanded" src="/assets/icons/results/search.svg" alt="search" />
    </div>

    <mat-form-field *ngIf="isExpanded" class="search-bar" appearance="outline">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput type="text" [(ngModel)]="searchText" (blur)="collapseSearch()"
        (keydown.enter)="onSearchCareer()" />
    </mat-form-field>
  </div>
</div>
<div class="filter-div">
  <div 
    class="filter-card" 
    [class.filter-card-active]="showFilterOptions" 
    (click)="toggleFilterOptions()"
    (keydown.enter)="toggleFilterOptions()"
    (keydown.space)="$event.preventDefault();toggleFilterOptions()"
    tabindex="0" 
    role="button"
  >
    <img src="/assets/icons/results/filter.svg" alt="filter" />
    <p>Filter Careers</p>
  </div>

  <div class="dropdown-container">
    <label for="sortby_dropdown" class="sort-by-text">Sort By:</label>
    <select id="sortby_dropdown" class="dropdown" (change)="sortResults($event)">
      <option value="">Highest match</option>
      @for (sortBy of sortByOptions; track $index) {
      <option [value]="sortBy">{{ sortBy }}</option>
      }
    </select>
    <span class="dropdown-arrow">
      <img src="/assets/icons/results/dropdown-arrow.svg" alt="dropdown" />
    </span>
  </div>
</div>
<div 
  class="filter-options-div" 
  [class]="showFilterOptions ? 'show-filter' : ''" 
  [attr.tabindex]="showFilterOptions ? '0' : '-1'"
>
  <form>
    <div class="arears-div">
      <div class="area-header">
        <p class="title">Career Areas</p>
        <div class="filter-actions">
          <p class="clear-text" (click)="clearFilters()" (keydown.enter)="clearFilters()" (keydown.space)="$event.preventDefault(); clearFilters()" tabindex="0" role="button">
            Reset Filters
          </p>
          <button mat-flat-button type="button" class="apply-btn" (click)="applyFilters()">
            Apply
          </button>
        </div>
      </div>
      <div class="area-option-div">
        @for (item of careerAreas; track $index) {
        <div class="areas" [class]="selectedArea.includes(item.name) ? 'area-active' : ''"
          (click)="selectArea(item.name)" (keydown.enter)="selectArea(item.name)" (keydown.space)="$event.preventDefault(); selectArea(item.name)" tabindex="0" role="button">
          <img [src]="'/assets/icons/sectors/' + item.icon" />
          <p>{{ item.name }}</p>
        </div>
        }
        <div class="areas" [class]="selectedArea.length == 0 ? 'area-active' : ''" (click)="selectArea('all')" (keydown.enter)="selectArea('all')" (keydown.space)="$event.preventDefault(); selectArea('all')" tabindex="0" role="button">
          <p>All</p>
        </div>
      </div>
    </div>
    <div class="other-filters">
      <div class="quality-div" [formGroup]="quality">
        <div class="match-div margin-1">
          <p class="title">Match Rank</p>
          <img src='/assets/icons/summary/info-circle.svg' alt="info" [matTooltip]="matchRankTooltip"
            matTooltipPosition="after" />
        </div>
        <div class="checkbox-list">
          <mat-checkbox formControlName="h1_plus" (change)="onQualityChange('h1_plus', $event.checked)">HI+ Match</mat-checkbox>
          <mat-checkbox formControlName="h1" (change)="onQualityChange('h1', $event.checked)">HI Match</mat-checkbox>
          <mat-checkbox formControlName="med" (change)="onQualityChange('med', $event.checked)">MED Match</mat-checkbox>
          <mat-checkbox formControlName="low" (change)="onQualityChange('low', $event.checked)">LO Match</mat-checkbox>
        </div>
      </div>

      <div class="education-div" [formGroup]="education">
        <p class="title margin-1">Education Investment</p>
        <div class="checkbox-list">
          <mat-checkbox formControlName="high_school" (change)="onEducationChange('high_school', $event.checked)">High School Diploma or equivalent</mat-checkbox>
          <mat-checkbox formControlName="associate_degree" (change)="onEducationChange('associate_degree', $event.checked)">Associate's Degree or Vocational school</mat-checkbox>
          <mat-checkbox formControlName="bachelor_degree" (change)="onEducationChange('bachelor_degree', $event.checked)">4 Year Bachelor's Degree</mat-checkbox>
          <mat-checkbox formControlName="graduate" (change)="onEducationChange('graduate', $event.checked)">Graduate School (Master's, Ph.D, M.D., J.D.)</mat-checkbox>
        </div>
      </div>

      <div class="salary-div">
        <p class="title">Salary Range</p>
        <div class="salary-range-container">
          <div class="salary-range" [formGroup]="salary">
            <div class="range-value">30</div>
            <mat-slider min="30" max="240" discrete="true" (change)="onSalaryChange()">
              <input formControlName="min_value" value="70" matSliderStartThumb>
              <input formControlName="max_value" value="240" matSliderEndThumb>
            </mat-slider>
            <div class="range-value">240</div>
          </div>
          <div class="salary-labels">
            <span class="salary-label-start">$30K</span>
            <span class="salary-label-end">$240K</span>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>